/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import CSSModules from 'react-css-modules';

import Label from '../common/Label';
import { formatDateTime } from '../../utils/converters/dateConverters';
import { BULL } from '../../constants/chars';
import {
  POST_REPLIES,
  POST_COMMENT_DESCRIPTION,
  POST_REPLY_DESCRIPTION,
  COMMUNITY_COMMENT_UPDATED,
  COMMON,
} from '../../constants/strings';

import styles from './index.styl';

const composeSubtitle = (comments, replyTo, formatMessage) => {
  if (comments) {
    const commentsText =
      comments &&
      comments.length > 0 &&
      `${BULL} ${comments.length} ${formatMessage(POST_REPLIES)}`;

    const staticText = formatMessage(POST_COMMENT_DESCRIPTION);

    return commentsText ? `${staticText} ${commentsText}` : staticText;
  }

  return replyTo
    ? formatMessage(POST_REPLY_DESCRIPTION, { name: replyTo })
    : '';
};

const Heading = ({
  userName,
  comments,
  createdAt,
  replyTo,
  updated,
  intl: { formatMessage },
  isNewComment,
  onTitleClick,
}) => {
  const subtitle = composeSubtitle(comments, replyTo, formatMessage);
  const time = createdAt && formatDateTime(createdAt, formatMessage);

  return (
    <div styleName="heading">
      <div styleName="heading__title">
        <div>
          <span onClick={onTitleClick} className="pointer">
            {userName}
          </span>
          <span styleName="heading__subtitle">{subtitle}</span>
        </div>
      </div>
      <div styleName="heading__time">
        <span className="mr2">{time}</span>
        <If condition={updated}>
          <span>
            {' '}
            (<FormattedMessage {...COMMUNITY_COMMENT_UPDATED} />)
          </span>
        </If>
        <If condition={isNewComment}>
          <Label text={formatMessage(COMMON.new)} additionalClass="uppercase" />
        </If>
      </div>
    </div>
  );
};

Heading.propTypes = {
  userName: PropTypes.string,
  comments: PropTypes.array, // todo
  createdAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  replyTo: PropTypes.string,
  updated: PropTypes.bool,
  isNewComment: PropTypes.bool,
  onTitleClick: PropTypes.func,
};

Heading.defaultProps = {
  isNewComment: false,
  onTitleClick: null,
};

const StyledHeading = CSSModules(Heading, styles, { allowMultiple: true });
export default injectIntl(StyledHeading);



// WEBPACK FOOTER //
// ./src/components/Comment/Heading.jsx